import React, { useEffect } from "react";
import {
  Image,
  View,
  // Heading,
  useTheme,
  Grid,
} from "@aws-amplify/ui-react";
import fourzerofour from "../assets/images/404.png";
import "./NoMatch.css";

export const NoMatch = () => {

    const { tokens } = useTheme();
    
    useEffect(() => { document.body.style.backgroundColor = 'white' }, [])

    return (
      
      <Grid
        templateColumns={{
          base: "1fr",
          medium: "2fr 4fr 2fr",
          large: "3fr 6fr 3fr",
        }}
        templateRows={{
          base: "repeat(5, 6rem)",
          medium: "repeat(6, 6rem)",
          large: "repeat(5, 6rem)",
        }}
        gap={tokens.space.small}
        backgroundColor="white"
        marginRight={"3em"}
        marginLeft={"3em"}
      >
        <View
          rowSpan={{ base: 1, medium: 6, large: 6 }}
          backgroundColor="white"
          textAlign="left"
        ></View>
        <View
          rowSpan={{ base: 8, medium: 6, large: 6 }}
          backgroundColor="inherit"
          textAlign="center"
          marginLeft={{ base: "1em", medium: "1em", large: "1em" }}
          marginTop={{ base: "1em", medium: "3em", large: "3em" }}
        >
          <Image
            src={fourzerofour}
            width={{ base: "50%" }}
            objectFit={{ base: "contain", medium: "contain", large: "contain" }}
            justifyContent={{
              base: "center",
              medium: "space-between",
              large: "space-between",
            }}
            alignItems="center"
            marginLeft={"1rem"}
            marginRight={"1rem"}
            marginTop={{ base: "3rem", medium: "1rem", large: "1rem" }}
          />
          {/* <Heading
            level={7}
            marginBottom={{ base: "1em", medium: "2em", large: "2em" }}
          >
            Non hai interrotto Internet, ma non riusciamo a trovare quello che stavi cercando
          </Heading> */}

        </View>
        <View
          rowSpan={{ base: 1, medium: 6, large: 6 }}
          backgroundColor="inherit"
          textAlign="left"
        ></View>
      </Grid>
    );
  };

  